var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIconDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46020_24288)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#125266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7071 35.1518L49.4604 24.0806C50.3773 23.7151 51.2853 24.6282 50.9153 25.5443L42.4596 46.4933C42.2126 47.105 41.4956 47.3723 40.9096 47.072L21.6111 37.1942C20.7531 36.7547 20.8111 35.5082 21.7061 35.1518H21.7071Z",
    stroke: "#2B7C95",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5728 24.248L30.2773 41.6348V46.877C30.2773 47.8021 31.3313 48.3298 32.0703 47.7761L36.2132 44.6734",
    stroke: "#2B7C95",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46020_24288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconDisabled);
export default __webpack_public_path__ + "static/media/sendIconDisabled.909778c6c83e7b88358bc6143bc39907.svg";
export { ForwardRef as ReactComponent };